// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1675271001859
      var cssReload = require("F:/Artem.js/starway/medteh/static/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  